import CardCredentialIdentityScreen from 'features/cardManagement/screens/cardCredentialChallenge/CardCredentialIdentityScreen/CardCredentialIdentityScreen';
import React from 'react';

export default function CardCredentialIdentityPage() {
  return <CardCredentialIdentityScreen />;
}
